export default __webpack_public_path__ + "static/media/Mobile login-bro.a5533c02.svg";